import React from 'react';

import { usePreviewPanelsActions } from '@atlassian/preview-panels-api';

import { PARENT_PRODUCTS } from '../common/constants';

import ConfluencePagePreviewPanel from './confluence-page-preview-panel';

export const useConfluencePagePreviewPanel = (
	parentProduct: (typeof PARENT_PRODUCTS)[keyof typeof PARENT_PRODUCTS],
) => {
	const { open, close } = usePreviewPanelsActions();

	const openConfluencePagePreviewPanel = (title: string, url: string) => {
		open({
			panel: {
				id: `confluence-page-preview-panel-${title}`,
				type: 'confluence-page',
				content: () => (
					<ConfluencePagePreviewPanel
						props={{ title, url, parentProduct }}
						entryPoints={{}}
						extraProps={{}}
						queries={{}}
					/>
				),
			},
		});
	};

	const closeConfluencePagePreviewPanel = () => {
		const onClose = () => {};
		close(onClose);
	};

	return { openConfluencePagePreviewPanel, closeConfluencePagePreviewPanel };
};
